/* Olienfant: predictive search overlay. Opens from any [data-search-open]; results from sections/predictive-search. */
(function () {
  'use strict';
  if (window.__olSearch) return;
  window.__olSearch = true;

  var DEBOUNCE = 250;
  var LIMIT = 10;
  var timer = null;
  var controller = null;
  var lastTerm = '';

  function overlay() { return document.querySelector('[data-search-overlay]'); }

  function suggestUrl(term) {
    var base = (window.theme && theme.routes && theme.routes.predictiveSearch) || '/search/suggest';
    var params = new URLSearchParams();
    params.set('q', term);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', String(LIMIT));
    params.set('resources[options][unavailable_products]', 'last');
    params.set('section_id', 'predictive-search');
    return base + '?' + params.toString();
  }

  function setResults(el, html) {
    var results = el.querySelector('[data-predictive-results]');
    if (results) results.innerHTML = html;
  }

  function announce(el, text) {
    var live = el.querySelector('[data-predictive-live]');
    if (live) live.textContent = text;
  }

  function search(el, term) {
    if (controller) controller.abort();
    if (!term) {
      lastTerm = '';
      setResults(el, '');
      announce(el, '');
      el.removeAttribute('aria-busy');
      return;
    }
    if (term === lastTerm) return;
    controller = new AbortController();
    el.setAttribute('aria-busy', 'true');
    fetch(suggestUrl(term), { signal: controller.signal })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-predictive-content]');
        lastTerm = term;
        setResults(el, content ? content.outerHTML : '');
        var status = doc.querySelector('[data-predictive-status]');
        announce(el, status ? status.textContent.trim() : '');
        el.removeAttribute('aria-busy');
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        el.removeAttribute('aria-busy');
      });
  }

  function open(opener) {
    var el = overlay();
    if (!el || !window.theme || !theme.openOverlay) return false;
    // Close the phone menu first if the search is opened from inside it.
    var drawer = document.querySelector('[data-menu-drawer]');
    if (drawer && !drawer.hidden && !drawer.contains(el)) theme.closeOverlay(drawer);
    if (opener) opener.setAttribute('aria-expanded', 'true');
    theme.openOverlay(el, {
      focus: '[data-predictive-input]',
      onClose: function () {
        if (opener) opener.setAttribute('aria-expanded', 'false');
        if (controller) controller.abort();
        clearTimeout(timer);
        el.removeAttribute('aria-busy');
      }
    });
    var input = el.querySelector('[data-predictive-input]');
    if (input && input.value.trim()) search(el, input.value.trim());
    return true;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-search-open]');
    if (!opener) return;
    if (open(opener)) e.preventDefault();
  });

  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('[data-predictive-input]');
    if (!input) return;
    var el = input.closest('[data-search-overlay]');
    if (!el) return;
    clearTimeout(timer);
    var term = input.value.trim();
    timer = setTimeout(function () { search(el, term); }, term ? DEBOUNCE : 0);
  });

  // Enter submits the form to /search (native). Make sure an empty field does not submit an empty search.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-predictive-form]');
    if (!form) return;
    var input = form.querySelector('[data-predictive-input]');
    if (input && !input.value.trim()) { e.preventDefault(); input.focus(); }
  });

  // Arrow down from the field moves into the results; arrows move between result links.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var el = e.target.closest && e.target.closest('[data-search-overlay]');
    if (!el) return;
    var links = Array.prototype.slice.call(el.querySelectorAll('[data-predictive-results] a'));
    if (!links.length) return;
    var input = el.querySelector('[data-predictive-input]');
    var idx = links.indexOf(document.activeElement);
    if (e.target === input && e.key === 'ArrowDown') { e.preventDefault(); links[0].focus(); return; }
    if (idx === -1) return;
    e.preventDefault();
    if (e.key === 'ArrowDown') { (links[idx + 1] || links[idx]).focus(); }
    else if (idx === 0) { input.focus(); }
    else { links[idx - 1].focus(); }
  });
})();
